// extracted by mini-css-extract-plugin
module.exports = {"InnerWrapper":"Bigger_InnerWrapper__2BJ-m","Top":"Bigger_Top__3fFkf","ImageWrapper":"Bigger_ImageWrapper__2y_GE","Text":"Bigger_Text__mA22L","Bottom":"Bigger_Bottom__2UzXs"};